"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const datasetContext_1 = __importDefault(require("../context/dataset/datasetContext"));
const chartContext_1 = __importDefault(require("../context/chart/chartContext"));
const jsonpath_1 = __importDefault(require("jsonpath"));
const CheckboxForm = ({ title, data, selectedDataset, datasetWrapper }) => {
    const [dataList, setDataList] = (0, react_1.useState)([]);
    const [collapsed, setCollapsed] = (0, react_1.useState)(false);
    const datasetContext = (0, react_1.useContext)(datasetContext_1.default);
    const chartContext = (0, react_1.useContext)(chartContext_1.default);
    const { chartDataList, chartLabels, getChartsData, removeChartsDataByLabel } = chartContext;
    const { jsonDataByIdList, jsonDataCategory } = datasetContext;
    let chartDataListCopy = JSON.parse(JSON.stringify(chartDataList));
    (0, react_1.useEffect)(() => {
        let tempDataList = [];
        data.forEach((item) => {
            tempDataList.push({
                json: item,
                isChecked: false,
            });
        });
        setDataList(tempDataList);
    }, []);
    (0, react_1.useEffect)(() => {
        handleDisableOtherElements();
        handleChangeFunction();
    }, [dataList]);
    const handleDisableOtherElements = () => {
        const wrapperDiv = datasetWrapper.current;
        if (dataList.some((dataItem) => dataItem.isChecked === true)) {
            for (let child of wrapperDiv.children) {
                if (child.getAttribute("data-title") !== title) {
                    if (child.nodeName === "LI")
                        continue;
                    child.classList.add("disabled");
                }
            }
        }
        else {
            for (let child of wrapperDiv.children) {
                if (child.nodeName === "LI")
                    continue;
                child.classList.remove("disabled");
            }
        }
    };
    const handleChange = (e) => {
        const { name, checked } = e.target;
        if (name === "global-selection") {
            let tempDataList = dataList.map((dataItem) => {
                return Object.assign(Object.assign({}, dataItem), { isChecked: checked });
            });
            setDataList(tempDataList);
        }
        else {
            let tempUser = dataList.map((dataItem) => {
                return Object.keys(dataItem.json)[0] === name ? Object.assign(Object.assign({}, dataItem), { isChecked: checked }) : dataItem;
            });
            setDataList(tempUser);
        }
    };
    const handleChangeFunction = () => {
        jsonDataByIdList.forEach((dataset) => {
            const currentYear = parseInt(dataset.year);
            const currentTable = JSON.parse(dataset.json_data);
            const currentDataset = jsonpath_1.default.query(currentTable, `$..["${selectedDataset}"]`)[0];
            const objToSearch = jsonpath_1.default.query(currentDataset, `$..["${title}"]`)[0];
            if (objToSearch != null) {
                let foundElement = null;
                dataList.forEach((dataItem) => {
                    const currentLabel = Object.keys(dataItem.json)[0];
                    if (!dataItem.isChecked) {
                        removeChartsDataByLabel(currentLabel);
                    }
                });
                dataList.forEach((dataItem) => {
                    foundElement = chartDataListCopy.filter((element) => element.year === currentYear)[0];
                    const currentLabel = Object.keys(dataItem.json)[0];
                    const currentValue = jsonpath_1.default.query(objToSearch, `$..["${currentLabel}"]`)[0];
                    if (dataItem.isChecked) {
                        if (foundElement != null) {
                            if (!chartLabels.includes(currentLabel))
                                foundElement.data.push(currentValue);
                        }
                        else {
                            chartDataListCopy.push({
                                year: currentYear,
                                data: [currentValue],
                            });
                        }
                        if (!chartLabels.includes(currentLabel)) {
                            getChartsData(selectedDataset, currentLabel, chartDataListCopy, jsonDataCategory);
                        }
                    }
                });
            }
        });
    };
    const onChange = (e) => {
        handleChange(e);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("form", { className: "text-white bg-agrey-444", "data-title": title },
            react_1.default.createElement("div", { className: "flex items-center pl-6" },
                react_1.default.createElement("input", { className: "form-check-input float-left\n              mr-2 h-4 w-4 cursor-pointer appearance-none\n              rounded-sm border border-gray-300 bg-[#ffffff]\n              bg-contain bg-center bg-no-repeat align-top transition\n              duration-200 checked:border-blue-600 checked:bg-blue-600\n              focus:outline-none", type: "checkbox", name: "global-selection", checked: !dataList.some((dataItem) => dataItem.isChecked !== true), onChange: onChange }),
                react_1.default.createElement("label", { className: "flex cursor-pointer items-center h-12 p-3 pr-20 flex-1 dropdown-label", onClick: () => setCollapsed(!collapsed) }, title.charAt(0).toUpperCase() + title.slice(1))),
            react_1.default.createElement("ul", { className: `pl-10 bg-agrey-666 ${collapsed ? "" : "collapsed"}` }, dataList.map((item, index) => {
                const { json } = item;
                const label = Object.keys(json)[0];
                return (react_1.default.createElement("li", { key: index, className: "flex items-center p-4" },
                    react_1.default.createElement("input", { className: "form-check-input float-left\n                    mr-2 h-4 w-4 cursor-pointer appearance-none\n                    rounded-sm border border-gray-300 bg-[#ffffff]\n                    bg-contain bg-center bg-no-repeat align-top transition\n                    duration-200 checked:border-blue-600 checked:bg-blue-600\n                    focus:outline-none", type: "checkbox", name: label, checked: item.isChecked || false, onChange: onChange }),
                    react_1.default.createElement("label", null, label.charAt(0).toUpperCase() + label.slice(1))));
            })))));
};
exports.default = CheckboxForm;
